import { z } from 'zod';
import { Moment, isMoment } from 'moment';

export const momentSchema = z.custom<Moment>(val => isMoment(val));
